import Vue from 'vue';
import { extend, ValidationObserver, ValidationProvider,localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { max } from 'vee-validate/dist/rules';
import { veeValidateLocale } from './locale';


Object.entries(rules).forEach(([rule, validation]) => {
    extend(rule, {
        ...validation,
    });
});

localize({
    en: veeValidateLocale.en,
    vi: veeValidateLocale.vi,
});
extend('commonMax', {
    ...max,
    message: (field, rules) => {
        return `common.common.validation.max|length: ${rules.length}|I18n`;
    },
});

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
